import React from 'react';
import { SvgIconProps } from '@mui/material';

export const TrashIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 5.00008H2.66667M2.66667 5.00008H16M2.66667 5.00008V16.6667C2.66667 17.1088 2.84226 17.5327 3.15482 17.8453C3.46738 18.1578 3.89131 18.3334 4.33333 18.3334H12.6667C13.1087 18.3334 13.5326 18.1578 13.8452 17.8453C14.1577 17.5327 14.3333 17.1088 14.3333 16.6667V5.00008H2.66667ZM5.16667 5.00008V3.33341C5.16667 2.89139 5.34226 2.46746 5.65482 2.1549C5.96738 1.84234 6.39131 1.66675 6.83333 1.66675H10.1667C10.6087 1.66675 11.0326 1.84234 11.3452 2.1549C11.6577 2.46746 11.8333 2.89139 11.8333 3.33341V5.00008M6.83333 9.16675V14.1667M10.1667 9.16675V14.1667"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TrashIcon;
